import * as Cookies from 'js-cookie';
import { AppState } from './AppState';

export const initialState: AppState = {
  api: {},
  errors: {
    lastHttpStatus: 200,
  },
  authState: {
    token: Cookies.get('BRIGIT_SITE_TOKEN'),
    registered: Cookies.get('BRIGIT_SITE_TOKEN') != null,
  },
  oneLinkUrl: null,
  config: null,
  userData: {
    firstDate: null,
    transactionCount: 0,
    accounts: 0,
    linked: false,
    kickoffId: null,
    institutionName: undefined,
    feeTransactions: {},
  },
  utmData: {
    campaignSource: undefined,
    campaignMedium: undefined,
    campaignName: undefined,
    campaignTerm: undefined,
    campaignContent: undefined,
    gclid: undefined,
    irclickid: undefined,
  },
  webAppCta: undefined,
};

export function hydrateInitialState(): AppState {
  return { ...initialState };
}
